import React from 'react'

import { Portlet, Form, Row, Col } from '_zari/core'

import * as Formatos from './formatos'

const TIPOSREPORTE = {
  LIBRODIARIO5_1: '1',
  LIBRODIARIO5_2: '2',
  DIARIORESUMEN: '3',
  LISTAASIENTOS: '4'
}

const ReporteDiario = () => {
  const [tipoReporte, setTipoReporte] = React.useState(TIPOSREPORTE.LIBRODIARIO5_1)

  return (
    <Portlet>
      <Portlet.Header title='Libro Diario' />
      <Portlet.Body>
        <Row>
          <Col md={3}>
            <Form.Radio
              id='radio-librodiario5.1'
              name='tipoReporte'
              label='LIBRO DIARIO 5.1'
              value={TIPOSREPORTE.LIBRODIARIO5_1}
              checked={tipoReporte === TIPOSREPORTE.LIBRODIARIO5_1}
              onChange={() => setTipoReporte(TIPOSREPORTE.LIBRODIARIO5_1)}
            />
            <Form.Radio
              id='radio-librodiario5.2'
              name='tipoReporte'
              label='LIBRO DIARIO 5.2'
              value={TIPOSREPORTE.LIBRODIARIO5_2}
              checked={tipoReporte === TIPOSREPORTE.LIBRODIARIO5_2}
              onChange={() => setTipoReporte(TIPOSREPORTE.LIBRODIARIO5_2)}
            />
            <Form.Radio
              id='radio-diarioresumen'
              name='tipoReporte'
              label='DIARIO RESUMEN'
              value={TIPOSREPORTE.DIARIORESUMEN}
              checked={tipoReporte === TIPOSREPORTE.DIARIORESUMEN}
              onChange={() => setTipoReporte(TIPOSREPORTE.DIARIORESUMEN)}
            />
            <Form.Radio
              id='radio-listaAsientos'
              name='tipoReporte'
              label='LISTA DE ASIENTOS'
              value={TIPOSREPORTE.LISTAASIENTOS}
              checked={tipoReporte === TIPOSREPORTE.LISTAASIENTOS}
              onChange={() => setTipoReporte(TIPOSREPORTE.LISTAASIENTOS)}
            />
          </Col>
          <Col md={9} style={{ borderLeft: '1px solid black' }}>
            {tipoReporte === TIPOSREPORTE.LIBRODIARIO5_1 && <Formatos.Formato5p1 />}
            {tipoReporte === TIPOSREPORTE.LIBRODIARIO5_2 && <Formatos.Formato5p2 />}
            {tipoReporte === TIPOSREPORTE.DIARIORESUMEN && <Formatos.FormatoDiarioResumen />}
            {tipoReporte === TIPOSREPORTE.LISTAASIENTOS && <Formatos.FormatoListaAsientos />}
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReporteDiario)
